/* eslint-disable dot-notation */
/* global EventSource */
// @flow
import { createAction } from 'redux-act';

import type { Dispatch, GetState } from '../../types';

type SSEEvent = {
  event: string,
  data: string,
};

export type MakeSSEListeners = () => (
  dispatch: Dispatch,
  getState: GetState,
) => {
  [event: string]: void | (SSEEvent => mixed),
  ...
};

export const failed: {
  (...mixed): { meta?: mixed, payload: mixed, type: string, ... },
  assignTo: mixed => void,
  assigned: () => boolean,
  bindTo: mixed => mixed,
  bound: () => boolean,
  dispatched: () => boolean,
  getType: () => string,
  raw: () => mixed,
  toString: () => string,
  ...
} = createAction('[SSE] Connection failed');

function resetSSEListeners() {
  return {
    done: undefined,
  };
}

let evtSource;
let SSEListeners = resetSSEListeners();

export const closeEventSource = () => {
  Object.keys(SSEListeners).forEach(event => {
    // SSE Polyfill does not provide a `removeEventListener` function
    // $FlowFixMe[method-unbinding]
    if (typeof evtSource.removeEventListener === 'function') {
      if (typeof SSEListeners[event] === 'function') {
        evtSource.removeEventListener(event, SSEListeners[event]);
      }
    }
  });
  SSEListeners = resetSSEListeners();
  evtSource.close();
};

/**
 * Start a SSE Connection to given URL
 * Close existing SSE Connection if any
 * Build Event Handlers if needed
 * Register Event Handlers
 */
export const startSSE =
  (url: string, makeSSEListeners?: MakeSSEListeners): (Dispatch => void) =>
  dispatch => {
    if (evtSource) {
      closeEventSource();
    }

    evtSource = new EventSource(url);
    if (makeSSEListeners) {
      SSEListeners = dispatch(makeSSEListeners());
    }

    Object.keys(SSEListeners).forEach(event => {
      if (typeof SSEListeners[event] === 'function') {
        evtSource.addEventListener(event, SSEListeners[event], false);
      }
    });
  };

/**
 * Stop SSE Connexion
 */
export const stopSSE = () => {
  if (SSEListeners?.done && typeof SSEListeners['done'] === 'function') {
    SSEListeners.done();
  }
};
